import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class RecentProjects extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let projects = this.props.projects;
        let handleClickTop = this.props.handleClickTop;
        let home_featured = projects.data.home_featured ? projects.data.home_featured : [];
        home_featured=home_featured.slice(-3);
        let projects_html = home_featured.map((item, key) => {
            return (
                <Link to={`${process.env.PUBLIC_URL}/project/${item.post_name}`} className="project-item" key={key}>
                    <figure>
                        <img src={item.featured_image.url} alt={item.post_title} title={item.post_title} />
                        <figcaption>
                            <h5 className="head">{item.post_title}</h5>
                            {
                                item.post_excerpt != '' &&
                                    <div className="desc">
                                        <p>{item.post_excerpt}</p>
                                    </div>
                            }
                            <span className="btn-arw right">Read More</span>
                        </figcaption>
                    </figure>
                </Link>
            )
        })
        return (
            <section className="section" style={{backgroundColor: '#eeeeee'}}>
                <div className="main-container">
                    <div className="ll__projects-grid portrait">
                        <h2 className="title-lg  sec-title">Projects</h2>
                        <div className="grid-3">
                            {projects_html}
                        </div>
                        <Link  to={`${process.env.PUBLIC_URL}/projects`} className="btn-arw right dark">All projects</Link>
                        <a href="javascript:" className="btn-arw-top backToTop" onClick={handleClickTop}>Back to top</a>
                    </div>
                </div>
            </section>
        );
    }
}

export default RecentProjects;


// WEBPACK FOOTER //
// ./src/components/Home/RecentProjects.js